export default [{
  path: '/perfil',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Editar Perfil',
      path: 'edit',
      component: () => import('@/views/perfil/Edit.vue'),
      meta: {
        requiresAuth: true,
        routeReleasedForLite: true,
        breadcrumb: [
          { name: "Meu Perfil" }
        ]
      }
    },
    {
      name: 'Logout',
      path: 'logout',
      component: () => import('@/views/perfil/Logout.vue'),
      meta: {
        requiresAuth: true,
        routeReleasedForLite: true
      }
    }
  ]
}]